import { normalizePhone } from "../../../shared/lib/phone.js"

const STORAGE_PREFIX = "offercraft:commercial-offer-client"

function getStorageKey(scope, userId, entityId) {
  if (!scope || !userId || !entityId) {
    return null
  }

  return `${STORAGE_PREFIX}:${scope}:${userId}:${entityId}`
}

function collapseSpaces(value) {
  return String(value || "").trim().replace(/\s+/g, " ")
}

export function validateCommercialOfferClientInfo(clientInfo) {
  const clientName = collapseSpaces(clientInfo?.clientName)
  const phoneResult = normalizePhone(clientInfo?.clientPhone)

  if (!clientName) {
    return {
      isValid: false,
      message: "Введите имя клиента"
    }
  }

  if (clientName.length > 120) {
    return {
      isValid: false,
      message: "Имя клиента не должно быть длиннее 120 символов"
    }
  }

  if (!phoneResult.isValid) {
    return phoneResult
  }

  return {
    isValid: true,
    value: {
      clientName,
      clientPhone: phoneResult.value
    }
  }
}

export function loadCommercialOfferClientInfo(scope, userId, entityId) {
  const key = getStorageKey(scope, userId, entityId)
  if (!key) {
    return null
  }

  try {
    const payload = JSON.parse(localStorage.getItem(key) || "null")
    const validation = validateCommercialOfferClientInfo(payload)

    if (!validation.isValid) {
      localStorage.removeItem(key)
      return null
    }
    return validation.value
  } catch {
    return null
  }
}

export function saveCommercialOfferClientInfo(scope, userId, entityId, clientInfo) {
  const key = getStorageKey(scope, userId, entityId)
  const validation = validateCommercialOfferClientInfo(clientInfo)

  if (!key || !validation.isValid) {
    return validation
  }

  localStorage.setItem(key, JSON.stringify(validation.value))

  return validation
}
